import React, { useState, useEffect } from "react"
import MetaTags from "react-meta-tags"
import {
    Row,
    Col,
    Card,
    CardBody,
    Container,
    Button,
    Input,
    Form,
} from "reactstrap"
import { useNavigate } from "react-router-dom"
import withRouter from "components/Common/withRouter"
import { withTranslation } from "react-i18next"
import PropTypes from "prop-types"
import CustomTable from "Custom/TableWithRemotePagination"
import * as Yup from "yup"
import { Field, FormikProvider, useFormik } from "formik"
import CustomSelect from "Custom/CustomSelect"
import { get, post } from "helpers/api_helper"
import { GET_CustomerPayments, POST_DeleteCancelPO } from "helpers/url_helper"
import { Spin } from "antd"
import swal from "sweetalert"
import { columns } from "./columns"
import { useSelector } from "react-redux"

const CustomerPayments = () => {
    const navigate = useNavigate()
    const [totalSize, setTotalSize] = useState(0)
    const [isLoading, setIsLoading] = useState(false)
    const [customerPayments, setCustomerPayments] = useState([])
    const [currentPage, setCurrentPage] = useState(1)
    const [currentSizePerPage, setCurrentSizePerPage] = useState(10)
    const AuthUser = JSON.parse(localStorage.getItem("authUser"))
    const userCompanyInfo = JSON.parse(localStorage.getItem("userCompanyInfo"))
    const companyid  = useSelector(state=>state?.Login?.currentCompanyId)
    let Cid = AuthUser?.org === true ? userCompanyInfo?.organization?.id : companyid
  
    const getData = (page = 1, sizePerPage = 10) => {
        setIsLoading(true)
        get(
            GET_CustomerPayments +
            "?page=" +
            page +
            "&paginate=" +
            sizePerPage +
            (Search ? "&search=" + Search : "") +
            (Cid ? "&contact_id=" + Cid : "") +
            (SearchByColumn ? "&column_filter=" + SearchByColumn : "") +
            (Status ? "&status_filter=" + Status : "")
        )
            .then(res => {
                if (res?.data?.data?.length > 0) {
                    setCustomerPayments(
                        res?.data?.data?.map((e) => {
                            e['Actions'] = <div className="d-flex">
                                <Button
                                    className="btn btn-secondary waves-effect waves-light btn btn-secondary"
                                    style={{
                                        width: "25px",
                                        height: "25px",
                                        padding: "0px",
                                    }}
                                    title="Delete"
                                    onClick={() => {
                                        delete_po(e.id)
                                    }}
                                >
                                    <i
                                        className="fas fa-trash-alt"
                                        style={{
                                            color: "red",
                                        }}
                                    ></i>
                                </Button>
                            </div>
                            return e
                        })
                    )
                    setTotalSize(res?.data?.total)
                    setIsLoading(false)
                } else {
                    setCustomerPayments([])
                    setTotalSize(0)
                    setIsLoading(false)
                }
            })
            .catch(error => {
                console.log(error)
                setIsLoading(false)
            })
        setCurrentPage(page)
        setCurrentSizePerPage(sizePerPage)
    }

    const validationSchemaFilter = Yup.object().shape({})

    const formikFilter = useFormik({
        validationSchema: validationSchemaFilter,
        onSubmit: (values, formikHelpers) =>
            handleValidSubmitFilter(values, formikHelpers),
        initialValues: {
            Status: "",
            Search: "",
            SearchByColumn: "",
        },
        validateOnBlur: false,
    })

    const {
        setFieldValue,
        values: { Search, Status, SearchByColumn },
    } = formikFilter

    const handleValidSubmitFilter = values => { }

    useEffect(() => {
        if(Cid){
            getData()
        }
    }, [Search, SearchByColumn, Status, Cid])

    const customerPaymentsOptions = [
        { label: "Purchase Order", value: "purchase_order" },
        { label: "Vendor Name", value: "vendor_name" },
    ]

    const statusOption = [
        { label: "DRAFT", value: "draft" },
        { label: "APPROVAL", value: "approval" },
        { label: "PENDING", value: "pending" },
        { label: "SEND", value: "send" },
    ]

    const delete_po = ID => {
        swal({
            title: "Are you sure you want to delete the purchase order?",
            text: "You won't be able to revert this!",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        }).then(willDo => {
            if (willDo) {
                delete_poConfirm(ID)
            }
        })
    }

    const delete_poConfirm = async ID => {
        setIsLoading(true)
        await post(POST_DeleteCancelPO, {
            po_id: ID,
            action: "delete",
        })
            .then(response => {
                if (response?.status == 200) {
                    swal({
                        title: "Delete Purchase Order",
                        text: response?.message,
                        icon: "success",
                        button: "OK",
                    })
                    getData(currentPage, currentSizePerPage)
                    setIsLoading(false)
                } else {
                    if (typeof response?.message == "string") {
                        swal({
                            title: "Error!",
                            text: response.message,
                            icon: "error",
                            button: "OK",
                        })
                    } else {
                        setSwalErrorMsg(response?.message)
                        setShowSwalError(true)
                    }
                    setIsLoading(false)
                }
            })
            .catch(error => {
                setIsLoading(false)
            })
    }

    return (
        <React.Fragment>
            <Spin size="large" spinning={isLoading} tip={"Loading..."}>
                <div className="page-content">
                    <MetaTags>
                        <title>{"Vendor Payments"} | Katlax OMS</title>
                    </MetaTags>

                    <Container fluid>
                        <>
                            <Row className="mt-3">
                                <Col lg={6}>
                                    <div className="mt-2" style={{ fontSize: "large" }}>
                                        <b>Customer Payments</b>
                                    </div>
                                </Col>
                                <Col lg={6} style={{ textAlign: "end" }}>
                                    <button
                                        className="btn btn-primary"
                                        onClick={() => {
                                            navigate("/customer-create-payments")
                                        }}
                                    >
                                        Add Customer Payment
                                    </button>
                                </Col>
                            </Row>
                            <Row className="mt-3">
                                <Col className="col-12">
                                    <FormikProvider value={formikFilter}>
                                        <Form onSubmit={formikFilter.handleSubmit}>
                                            <Row>
                                                <Col lg={12}>
                                                    <Row>
                                                        <Col lg={3} sm={6} md={3}>
                                                            <div className="form-group has-search">
                                                                <span className="fa fa-search form-control-feedback"></span>
                                                                <Input
                                                                    type="text"
                                                                    name="Search"
                                                                    className="form-control"
                                                                    placeholder="Search"
                                                                    value={Search}
                                                                    onChange={e => {
                                                                        formikFilter.setFieldValue(
                                                                            "Search",
                                                                            e.target.value
                                                                        )
                                                                    }}
                                                                />
                                                            </div>
                                                        </Col>
                                                        <Col lg={2} sm={6} md={2}>
                                                            <Field
                                                                name="SearchByColumn"
                                                                placeholder={"By Column"}
                                                                component={CustomSelect}
                                                                options={customerPaymentsOptions}
                                                            />
                                                        </Col>
                                                        <Col lg={2} md={2}>
                                                            <Field
                                                                name="Status"
                                                                placeholder={"Status"}
                                                                component={CustomSelect}
                                                                options={statusOption}
                                                            />
                                                        </Col>
                                                        <Col
                                                            lg={2}
                                                            className="mt-1"
                                                            style={{ textAlign: "left" }}
                                                        >
                                                            <div
                                                                onClick={() => {
                                                                    //setSearch("")
                                                                    formikFilter.setFieldValue("Status", "")
                                                                    formikFilter.setFieldValue("Search", "")
                                                                    formikFilter.setFieldValue(
                                                                        "SearchByColumn",
                                                                        ""
                                                                    )
                                                                }}
                                                            >
                                                                <i
                                                                    className="mdi mdi-filter-remove"
                                                                    style={{
                                                                        fontSize: "20px",
                                                                        color: "#4a539f",
                                                                    }}
                                                                ></i>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </Col>
                                            </Row>
                                        </Form>
                                    </FormikProvider>
                                    <Card>
                                        <CardBody className="table-fixed">
                                            <CustomTable
                                                keyField="Vendor"
                                                columns={columns}
                                                data={customerPayments}
                                                totalSize={totalSize}
                                                getData={getData}
                                            />
                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>
                        </>
                    </Container>
                </div>
            </Spin>
        </React.Fragment>
    )
}
CustomerPayments.propTypes = {
    t: PropTypes.any,
}

export default withRouter(withTranslation()(CustomerPayments))
